import UseFetchData from "./FetchData";

export default UseFetchData;
